export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.api.portal.canepayroll.com',
  auth0: {
    domain: 'dev-fqbwpstwv2cl7cur.us.auth0.com',
    clientId: 'LcECE3ZmGboyidVaaYhxmi1h6ZRkxzuo',
    audience: 'https://dev.api.portal.canepayroll.com',
  },
};
